var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkSocialeProfilerBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.91014 0 0 2.91014 0 6.5C0 10.0899 2.91014 13 6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91014 10.0899 0 6.5 0ZM6.5 1.25806C9.39701 1.25806 11.7419 3.60255 11.7419 6.5C11.7419 9.39701 9.39745 11.7419 6.5 11.7419C3.60299 11.7419 1.25806 9.39745 1.25806 6.5C1.25806 3.60299 3.60255 1.25806 6.5 1.25806ZM10.1747 4.67232L9.58404 4.07689C9.46172 3.95357 9.26258 3.95276 9.13926 4.07511L5.43447 7.75012L3.86734 6.17028C3.74502 6.04697 3.54588 6.04615 3.42256 6.16847L2.82711 6.75913C2.70379 6.88146 2.70298 7.0806 2.82532 7.20394L5.20467 9.60254C5.32699 9.72586 5.52613 9.72667 5.64944 9.60433L10.1729 5.11713C10.2962 4.99478 10.297 4.79564 10.1747 4.67232Z",
    fill: "#FD8533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkSocialeProfilerBanner);
export default __webpack_public_path__ + "static/media/Check-Mark-Social e-Profiler Banner.bd1053173b8de69bce621400d0d9bc69.svg";
export { ForwardRef as ReactComponent };